// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".event__trigger_f04d3552{width:100%;max-height:10.5rem;min-height:10rem;border:.084rem solid #dce1e5;border-radius:.333em;padding:.667rem}.event__trigger-text_d2af644d{white-space:pre-wrap;word-break:break-all}.event__deprecated_f426e501{background-color:#fef3db}", ""]);
// Exports
export var eventTrigger = "event__trigger_f04d3552";
export var eventTriggerText = "event__trigger-text_d2af644d";
export var eventDeprecated = "event__deprecated_f426e501";
export default ___CSS_LOADER_EXPORT___;
